import { useEffect, useState } from 'react';
import BasicTable from '../../../components/table';
import { api } from '../../../services/axios';
import { AddModal } from './styles';

import AddIcon from '@mui/icons-material/Add';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { Autocomplete, Box, Button, CircularProgress, Divider, FormControl, FormControlLabel, FormLabel, InputAdornment, InputLabel, MenuItem, Radio, RadioGroup, Select, Stack, Switch, TextField } from '@mui/material';
import { encode } from 'base-64';
import { ModalAlert, Test } from '../../../components/modal';
import { ModalAlertDiv } from '../../../components/modal/style';
import { TableBar } from '../../../components/table/styles';

import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';

// import Modal from "react-modal";
import Modal from '@mui/material/Modal';
import ModalDelete from '../../../components/modal/modalDelete';

const defaultForm = {
  name: '',
  MondayStart: '',
  MondayEnd: '',
  TuesdayStart: '',
  TuesdayEnd: '',
  WednesdayStart: '',
  WednesdayEnd: '',
  ThursdayStart: '',
  ThursdayEnd: '',
  FridayStart: '',
  FridayEnd: '',
  SaturdayStart: '',
  SaturdayEnd: '',
  SundayStart: '',
  SundayEnd: '',
}

const defaultError = {
  name: false,
  city: false,
  country: false,
  language: false,
  chatUrl: false,
  error: false
}

const Calendars = () => {
  const url = "core/ajax/calendars"

  const headers = [
    { label: 'Id', value: 'IdEngineCalendar' },
    { label: 'Name', value: 'Calendar' },

    { label: 'Sunday', value: 'SundayStart' },
    { label: 'Monday', value: 'MondayStart' },
    { label: 'Tuesday', value: 'TuesdayStart' },
    { label: 'Wednesday', value: 'WednesdayStart' },
    { label: 'Thursday', value: 'ThursdayStart' },
    { label: 'Friday', value: 'FridayStart' },
    { label: 'Saturday', value: 'SaturdayStart' },

    { label: 'Active', value: 'Active' },
    { label: 'Actions', value: 'Actions' },
  ]

  const [rows, setRows] = useState({ default: [], filter: [] })

  const [showModal, setShowModal] = useState(false)

  const [disable, setDisable] = useState({
    Monday: false,
    Tuesday: false,
    Wednesday: false,
    Thursday: false,
    Friday: false,
    Saturday: false,
    Sunday: false,
  })

  const [error, setError] = useState(defaultError)
  const [form, setForm] = useState(defaultForm);

  const [alert, setAlert] = useState({ msg: '', status: '' });
  const [showAlert, setShowAlert] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [id, setId] = useState();
  const [isCreate, setIsCreate] = useState(true);

  useEffect(() => {
    listUpdate()
  }, [])

  const listUpdate = () => {


    api.post(url, {
      type: 'list',
      authx: ''
    })
      .then(function (res) {
        setRows({
          default: res.data.map((e) => {
            return {
              ...e,
              IdEngineCalendar: Number(e.IdEngineCalendar),
            }
          }), filter: res.data.map((e) => {
            return {
              ...e,
              IdEngineCalendar: Number(e.IdEngineCalendar),
            }
          })
        })
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const createGenerator = () => {
    api.post(url, {
      type: 'insert',
      Calendar: form.name,

      checked1: disable.Monday,
      MondayStart: form.MondayStart,
      MondayEnd: form.MondayEnd,

      checked2: disable.Tuesday,
      TuesdayStart: form.TuesdayStart,
      TuesdayEnd: form.TuesdayEnd,

      checked3: disable.Wednesday,
      WednesdayStart: form.WednesdayStart,
      WednesdayEnd: form.WednesdayEnd,

      checked4: disable.Thursday,
      ThursdayStart: form.ThursdayStart,
      ThursdayEnd: form.ThursdayEnd,

      checked5: disable.Friday,
      FridayStart: form.FridayStart,
      FridayEnd: form.FridayEnd,

      checked6: disable.Saturday,
      SaturdayStart: form.SaturdayStart,
      SaturdayEnd: form.SaturdayEnd,

      checked7: disable.Sunday,
      SundayStart: form.SundayStart,
      SundayEnd: form.SundayEnd,

      authx: ''
    })
      .then(function (res) {
        setAlert(res.data)
        listUpdate()
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const updateForm = (row) => {
    setForm({
      name: row.Calendar,
      MondayStart: row.MondayStart.includes('-') ? '' : row.MondayStart.slice(0, 2) + ":" + row.MondayStart.slice(2),
      MondayEnd: row.MondayEnd.includes('-') ? '' : row.MondayEnd.slice(0, 2) + ":" + row.MondayEnd.slice(2),

      TuesdayStart: row.TuesdayStart.includes('-') ? '' : row.TuesdayStart.slice(0, 2) + ":" + row.TuesdayStart.slice(2),
      TuesdayEnd: row.TuesdayEnd.includes('-') ? '' : row.TuesdayEnd.slice(0, 2) + ":" + row.TuesdayEnd.slice(2),

      WednesdayStart: row.WednesdayStart.includes('-') ? '' : row.WednesdayStart.slice(0, 2) + ":" + row.WednesdayStart.slice(2),
      WednesdayEnd: row.WednesdayEnd.includes('-') ? '' : row.WednesdayEnd.slice(0, 2) + ":" + row.WednesdayEnd.slice(2),

      ThursdayStart: row.ThursdayStart.includes('-') ? '' : row.ThursdayStart.slice(0, 2) + ":" + row.ThursdayStart.slice(2),
      ThursdayEnd: row.ThursdayEnd.includes('-') ? '' : row.ThursdayEnd.slice(0, 2) + ":" + row.ThursdayEnd.slice(2),

      FridayStart: row.FridayStart.includes('-') ? '' : row.FridayStart.slice(0, 2) + ":" + row.FridayStart.slice(2),
      FridayEnd: row.FridayEnd.includes('-') ? '' : row.FridayEnd.slice(0, 2) + ":" + row.FridayEnd.slice(2),

      SaturdayStart: row.SaturdayStart.includes('-') ? '' : row.SaturdayStart.slice(0, 2) + ":" + row.SaturdayStart.slice(2),
      SaturdayEnd: row.SaturdayEnd.includes('-') ? '' : row.SaturdayEnd.slice(0, 2) + ":" + row.SaturdayEnd.slice(2),

      SundayStart: row.SundayStart.includes('-') ? '' : row.SundayStart.slice(0, 2) + ":" + row.SundayStart.slice(2),
      SundayEnd: row.SundayEnd.includes('-') ? '' : row.SundayEnd.slice(0, 2) + ":" + row.SundayEnd.slice(2),
    })
    setDisable({
      Monday: !row.MondayStart.includes('-') ? true : false,
      Tuesday: !row.TuesdayStart.includes('-') ? true : false,
      Wednesday: !row.WednesdayStart.includes('-') ? true : false,
      Thursday: !row.ThursdayStart.includes('-') ? true : false,
      Friday: !row.FridayStart.includes('-') ? true : false,
      Saturday: !row.SaturdayStart.includes('-') ? true : false,
      Sunday: !row.SundayStart.includes('-') ? true : false,
    })
    setIsCreate(false)
    setShowModal(true)
    setId(row.IdEngineCalendar)
  }

  const confirmUpdateForm = () => {
    api.post(url, {
      type: 'update',
      IdEngineCalendar: id,

      Calendar: form.name,

      checked1: disable.Monday,
      MondayStart: form.MondayStart,
      MondayEnd: form.MondayEnd,

      checked2: disable.Tuesday,
      TuesdayStart: form.TuesdayStart,
      TuesdayEnd: form.TuesdayEnd,

      checked3: disable.Wednesday,
      WednesdayStart: form.WednesdayStart,
      WednesdayEnd: form.WednesdayEnd,

      checked4: disable.Thursday,
      ThursdayStart: form.ThursdayStart,
      ThursdayEnd: form.ThursdayEnd,

      checked5: disable.Friday,
      FridayStart: form.FridayStart,
      FridayEnd: form.FridayEnd,

      checked6: disable.Saturday,
      SaturdayStart: form.SaturdayStart,
      SaturdayEnd: form.SaturdayEnd,

      checked7: disable.Sunday,
      SundayStart: form.SundayStart,
      SundayEnd: form.SundayEnd,

      authx: ''
    })
      .then(function (res) {
        setAlert(res.data)
        listUpdate()
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const onDelete = (id) => {
    setId(id)
    setShowDelete(!showDelete)
    setAlert({ status: "go" })
  }

  const confirmDelete = () => {
    api.post(url, {
      type: 'delete',
      IdEngineCalendar: id,
      authx: ''
    })
      .then(function (res) {
        setAlert(res.data)
        listUpdate()
      })
      .catch(function (error) {
        setAlert({ msg: 'Ocorreu um erro', status: 'error' })
        console.log(error);
      });
  }


  const validation = () => {
    if (form.name === '' ? true : false) {
      return false
    } else {
      return true
    }
  }

  const handleActive = (id, active) => {
    api.post(url, {
      type: 'activeCalendar',
      IdEngCal: id,
      active: active ? 1 : 0,
      authx: ''
    })
      .then(function (res) {
        setAlert(res.data)
        listUpdate()
      })
      .catch(function (error) {
        setAlert({ msg: 'Ocorreu um erro', status: 'error' })
        console.log(error);
      });
  }

  const inputFilter = (e) => {
    const filter = rows.default.filter((row) => {
      return row.Calendar.toLowerCase().includes(e.target.value.toLowerCase()) ||
        row.IdEngineCalendar.toString().includes(e.target.value) ||
        row.FridayEnd.includes(e.target.value) ||
        row.FridayStart.includes(e.target.value) ||
        row.MondayEnd.includes(e.target.value) ||
        row.MondayStart.includes(e.target.value) ||
        row.SaturdayEnd.includes(e.target.value) ||
        row.SaturdayStart.includes(e.target.value) ||
        row.SundayEnd.includes(e.target.value) ||
        row.SundayStart.includes(e.target.value) ||
        row.ThursdayEnd.includes(e.target.value) ||
        row.ThursdayStart.includes(e.target.value) ||
        row.TuesdayEnd.includes(e.target.value) ||
        row.TuesdayStart.includes(e.target.value) ||
        row.WednesdayEnd.includes(e.target.value) ||
        row.WednesdayStart.includes(e.target.value)
    });
    setRows({ ...rows, filter })
  }

  return (
    <TableBar>

      <h1>List Calendars</h1>
      <div className='buttons'>
        <TextField
          label="Search"
          variant="outlined"
          size='small'
          onChange={inputFilter}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchOutlinedIcon />
              </InputAdornment>
            ),
          }}
        />

        <Button startIcon={<AddIcon />} onClick={() => {
          setShowModal(!showModal)
          setIsCreate(true)
        }} variant="contained">Add</Button>
      </div>
      <BasicTable type={'calendars'} headers={headers} rowsProps={rows.filter} updateForm={updateForm} onDelete={onDelete} handleActive={handleActive} />
      {/* <Test>

      </Test> */}
      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false)
          setForm(defaultForm)
          setError(defaultError)
        }}
        // style={customStyles}
        className="mui-fixed">
        <Box sx={customStyles}>
          <AddModal>
            <h1>Calendars</h1>
            <Divider className='divider' variant="middle" />

            <TextField
              margin="dense"
              label="Name"
              variant="outlined"
              size='small'
              value={form.name}
              onChange={(e) => {
                e.target.value !== '' ? setError({ ...error, name: false }) : setError({ ...error, name: true })
                setForm({
                  ...form,
                  name: e.target.value
                })
              }} />

            <Stack
              direction="row"
              spacing={2}
              sx={{ margin: '1rem 0 .6rem 0' }}
              alignItems="center">
              <FormLabel id="demo-radio-buttons-group-label">Sunday</FormLabel>
              <Switch checked={disable.Sunday} onChange={(e, value) => {
                !value && setForm({ ...form, SundayStart: '', SundayEnd: '' })
                setDisable({ ...disable, Sunday: value })
              }} />
            </Stack>

            <Stack direction="row" spacing={2}>
              <Autocomplete
                clearOnEscape
                isOptionEqualToValue={(option, value) =>
                  value === undefined || value === "" || option === value
                }
                sx={{ flex: '1' }}
                size='small'
                className={'type'}
                disabled={!disable.Sunday}
                options={Hours}
                getOptionDisabled={(option) =>
                  form.SundayEnd !== '' && Hours.slice(Hours.indexOf(form.SundayEnd) - Hours.length).includes(option)
                }
                value={form.SundayStart}
                onChange={(event, value) => {
                  setForm({
                    ...form,
                    SundayStart: value
                  })
                }}
                renderInput={(params) => <TextField {...params}
                  label="Start" />}
              />
              <Autocomplete
                clearOnEscape
                sx={{ flex: '1' }}
                size='small'
                className={'type'}
                isOptionEqualToValue={(option, value) =>
                  value === undefined || value === "" || option === value
                }
                disabled={!disable.Sunday}
                options={Hours}
                getOptionDisabled={(option) =>
                  form.SundayStart !== '' && Hours.slice(0, Hours.indexOf(form.SundayStart)).includes(option)
                }
                value={form.SundayEnd}
                onChange={(event, value) => {
                  setForm({
                    ...form,
                    SundayEnd: value
                  })
                }}
                renderInput={(params) => <TextField {...params}
                  label="End" />}
              />
            </Stack>

            <Stack direction="row" spacing={2} sx={{ margin: '1rem 0 .6rem 0' }}
              alignItems="center">
              <FormLabel id="demo-radio-buttons-group-label">Monday</FormLabel>
              <Switch checked={disable.Monday} onChange={(e) => { setDisable({ ...disable, Monday: e.target.checked }) }} />
            </Stack>
            <Stack
              direction="row"
              spacing={2}
              alignItems="center">
              <Autocomplete
                sx={{ flex: '1' }}
                size='small'
                className={'type'}

                clearOnEscape
                disabled={!disable.Monday}
                options={Hours}
                getOptionDisabled={(option) =>
                  form.MondayEnd !== '' && Hours.slice(Hours.indexOf(form.MondayEnd) - Hours.length).includes(option)
                }

                isOptionEqualToValue={(option, value) =>
                  value === undefined || value === "" || option === value
                }
                value={form.MondayStart}
                onChange={(event, value) => {
                  setForm({
                    ...form,
                    MondayStart: value
                  })
                }}
                renderInput={(params) => <TextField {...params}
                  label="Start" />}
              />
              <Autocomplete
                sx={{ flex: '1' }}
                size='small'
                className={'type'}

                clearOnEscape
                disabled={!disable.Monday}
                options={Hours}
                getOptionDisabled={(option) =>
                  form.MondayStart !== '' && Hours.slice(0, Hours.indexOf(form.MondayStart)).includes(option)
                }

                isOptionEqualToValue={(option, value) =>
                  value === undefined || value === "" || option === value
                }
                value={form.MondayEnd}
                onChange={(event, value) => {
                  setForm({
                    ...form,
                    MondayEnd: value
                  })
                }}
                renderInput={(params) => <TextField {...params}
                  label="End" />}
              />
            </Stack>

            <Stack direction="row" spacing={2} sx={{ margin: '1rem 0 .6rem 0' }}
              alignItems="center">
              <FormLabel id="demo-radio-buttons-group-label">Tuesday</FormLabel>
              <Switch checked={disable.Tuesday} onChange={(e) => { setDisable({ ...disable, Tuesday: e.target.checked }) }} />
            </Stack>
            <Stack
              direction="row"
              spacing={2}
              alignItems="center">
              <Autocomplete
                sx={{ flex: '1' }}
                size='small'
                className={'type'}

                clearOnEscape
                disabled={!disable.Tuesday}
                options={Hours}
                getOptionDisabled={(option) =>
                  form.TuesdayEnd !== '' && Hours.slice(Hours.indexOf(form.TuesdayEnd) - Hours.length).includes(option)
                }

                isOptionEqualToValue={(option, value) =>
                  value === undefined || value === "" || option === value
                }
                value={form.TuesdayStart}
                onChange={(event, value) => {
                  setForm({
                    ...form,
                    TuesdayStart: value
                  })
                }}
                renderInput={(params) => <TextField {...params}
                  label="Start" />}
              />
              <Autocomplete
                sx={{ flex: '1' }}
                size='small'
                className={'type'}

                clearOnEscape
                disabled={!disable.Tuesday}
                options={Hours}
                getOptionDisabled={(option) =>
                  form.TuesdayStart !== '' && Hours.slice(0, Hours.indexOf(form.TuesdayStart)).includes(option)
                }

                isOptionEqualToValue={(option, value) =>
                  value === undefined || value === "" || option === value
                }
                value={form.TuesdayEnd}
                onChange={(event, value) => {
                  setForm({
                    ...form,
                    TuesdayEnd: value
                  })
                }}
                renderInput={(params) => <TextField {...params}
                  label="End" />}
              />
            </Stack>


            <Stack direction="row" spacing={2} sx={{ margin: '1rem 0 .6rem 0' }}
              alignItems="center">
              <FormLabel id="demo-radio-buttons-group-label">Wednesday</FormLabel>
              <Switch checked={disable.Wednesday} onChange={(e) => { setDisable({ ...disable, Wednesday: e.target.checked }) }} />
            </Stack>
            <Stack
              direction="row"
              spacing={2}
              alignItems="center">
              <Autocomplete
                sx={{ flex: '1' }}
                size='small'
                className={'type'}

                clearOnEscape
                disabled={!disable.Wednesday}
                options={Hours}
                getOptionDisabled={(option) =>
                  form.WednesdayEnd !== '' && Hours.slice(Hours.indexOf(form.WednesdayEnd) - Hours.length).includes(option)
                }

                isOptionEqualToValue={(option, value) =>
                  value === undefined || value === "" || option === value
                }
                value={form.WednesdayStart}
                onChange={(event, value) => {
                  setForm({
                    ...form,
                    WednesdayStart: value
                  })
                }}
                renderInput={(params) => <TextField {...params}
                  label="Start" />}
              />
              <Autocomplete
                sx={{ flex: '1' }}
                size='small'
                className={'type'}

                clearOnEscape
                disabled={!disable.Wednesday}
                options={Hours}
                getOptionDisabled={(option) =>
                  form.WednesdayStart !== '' && Hours.slice(0, Hours.indexOf(form.WednesdayStart)).includes(option)
                }

                isOptionEqualToValue={(option, value) =>
                  value === undefined || value === "" || option === value
                }
                value={form.WednesdayEnd}
                onChange={(event, value) => {
                  setForm({
                    ...form,
                    WednesdayEnd: value
                  })
                }}
                renderInput={(params) => <TextField {...params}
                  label="End" />}
              />
            </Stack>


            <Stack direction="row" spacing={2} sx={{ margin: '1rem 0 .6rem 0' }}
              alignItems="center">
              <FormLabel id="demo-radio-buttons-group-label">Thursday</FormLabel>
              <Switch checked={disable.Thursday} onChange={(e) => { setDisable({ ...disable, Thursday: e.target.checked }) }} />
            </Stack>
            <Stack
              direction="row"
              spacing={2}
              alignItems="center">
              <Autocomplete
                sx={{ flex: '1' }}
                size='small'
                className={'type'}

                clearOnEscape
                disabled={!disable.Thursday}
                options={Hours}

                isOptionEqualToValue={(option, value) =>
                  value === undefined || value === "" || option === value
                }
                getOptionDisabled={(option) =>
                  form.ThursdayEnd !== '' && Hours.slice(Hours.indexOf(form.ThursdayEnd) - Hours.length).includes(option)
                }
                value={form.ThursdayStart}
                onChange={(event, value) => {
                  setForm({
                    ...form,
                    ThursdayStart: value
                  })
                }}
                renderInput={(params) => <TextField {...params}
                  label="Start" />}
              />
              <Autocomplete
                sx={{ flex: '1' }}
                size='small'
                className={'type'}

                clearOnEscape
                disabled={!disable.Thursday}
                options={Hours}

                isOptionEqualToValue={(option, value) =>
                  value === undefined || value === "" || option === value
                }
                getOptionDisabled={(option) =>
                  form.ThursdayStart !== '' && Hours.slice(0, Hours.indexOf(form.ThursdayStart)).includes(option)
                }
                value={form.ThursdayEnd}
                onChange={(event, value) => {
                  setForm({
                    ...form,
                    ThursdayEnd: value
                  })
                }}
                renderInput={(params) => <TextField {...params}
                  label="End" />}
              />
            </Stack>


            <Stack direction="row" spacing={2} sx={{ margin: '1rem 0 .6rem 0' }}
              alignItems="center">
              <FormLabel id="demo-radio-buttons-group-label">Friday</FormLabel>
              <Switch checked={disable.Friday} onChange={(e) => { setDisable({ ...disable, Friday: e.target.checked }) }} />
            </Stack>
            <Stack
              direction="row"
              spacing={2}
              alignItems="center">
              <Autocomplete
                sx={{ flex: '1' }}
                size='small'
                className={'type'}

                clearOnEscape
                disabled={!disable.Friday}
                options={Hours}
                getOptionDisabled={(option) =>
                  form.FridayEnd !== '' && Hours.slice(Hours.indexOf(form.FridayEnd) - Hours.length).includes(option)
                }

                isOptionEqualToValue={(option, value) =>
                  value === undefined || value === "" || option === value
                }
                value={form.FridayStart}
                onChange={(event, value) => {
                  setForm({
                    ...form,
                    FridayStart: value
                  })
                }}
                renderInput={(params) => <TextField {...params}
                  label="Start" />}
              />
              <Autocomplete
                sx={{ flex: '1' }}
                size='small'
                className={'type'}

                clearOnEscape
                disabled={!disable.Friday}
                options={Hours}
                getOptionDisabled={(option) =>
                  form.FridayStart !== '' && Hours.slice(0, Hours.indexOf(form.FridayStart)).includes(option)
                }

                isOptionEqualToValue={(option, value) =>
                  value === undefined || value === "" || option === value
                }
                value={form.FridayEnd}
                onChange={(event, value) => {
                  setForm({
                    ...form,
                    FridayEnd: value
                  })
                }}
                renderInput={(params) => <TextField {...params}
                  label="End" />}
              />
            </Stack>


            <Stack direction="row" spacing={2} sx={{ margin: '1rem 0 .6rem 0' }}
              alignItems="center">
              <FormLabel id="demo-radio-buttons-group-label">Saturday</FormLabel>
              <Switch checked={disable.Saturday} onChange={(e) => { setDisable({ ...disable, Saturday: e.target.checked }) }} />
            </Stack>
            <Stack
              direction="row"
              spacing={2}
              alignItems="center">
              <Autocomplete
                sx={{ flex: '1' }}
                size='small'
                className={'type'}

                clearOnEscape
                disabled={!disable.Saturday}
                options={Hours}
                getOptionDisabled={(option) =>
                  form.SaturdayEnd !== '' && Hours.slice(Hours.indexOf(form.SaturdayEnd) - Hours.length).includes(option)
                }

                isOptionEqualToValue={(option, value) =>
                  value === undefined || value === "" || option === value
                }
                value={form.SaturdayStart}
                onChange={(event, value) => {
                  setForm({
                    ...form,
                    SaturdayStart: value
                  })
                }}
                renderInput={(params) => <TextField {...params}
                  label="Start" />}
              />
              <Autocomplete
                sx={{ flex: '1' }}
                size='small'
                className={'type'}

                clearOnEscape
                disabled={!disable.Saturday}
                options={Hours}
                getOptionDisabled={(option) =>
                  form.SaturdayStart !== '' && Hours.slice(0, Hours.indexOf(form.SaturdayStart)).includes(option)
                }

                isOptionEqualToValue={(option, value) =>
                  value === undefined || value === "" || option === value
                }
                value={form.SaturdayEnd}
                onChange={(event, value) => {
                  setForm({
                    ...form,
                    SaturdayEnd: value
                  })
                }}
                renderInput={(params) => <TextField {...params}
                  label="End" />}
              />
            </Stack>

            <Button sx={{ marginTop: '1rem' }} onClick={() => {
              setError({
                name: form.name === '' ? true : false,
              })
              if (validation()) {
                isCreate ? createGenerator() : confirmUpdateForm()
                setShowAlert(!showAlert)
              }
            }} variant="contained">{isCreate ? 'Create' : 'Update'}</Button>
          </AddModal>
        </Box>
      </Modal>
      <Modal
        open={showAlert}
        onClose={() => {
          setShowAlert(false)
          setAlert({ msg: '', status: undefined })
        }}
        // style={customStyles}
        className="mui-fixed">
        <Box sx={customStylesAlert}>
          {alert.status === undefined ?
            <ModalAlertDiv>
              <CircularProgress />
              <h2>Creating Calendar...</h2>
              <p>Please, wait...</p>
            </ModalAlertDiv>
            : alert.status === 'ok' ?
              <ModalAlertDiv>
                <CheckCircleOutlineOutlinedIcon color={"success"} style={{ fontSize: "4rem" }} />
                <h2>Success!</h2>

                <Button onClick={() => {
                  setShowAlert(false)
                }} variant="contained">Ok</Button>
              </ModalAlertDiv>
              :
              <ModalAlertDiv>
                <h3>Error :&#40;</h3>
                <h3>{alert.msg}</h3>

              </ModalAlertDiv>
          }
        </Box>
      </Modal>


      {/* Modal de delete */}
      <ModalDelete type={'calendar'} showDelete={showDelete} alert={alert} setShowDelete={setShowDelete} setAlert={setAlert} confirmDelete={confirmDelete} />

      {/* <ModalAlert showModal={showDelete} onClose={() => {
        setShowDelete(!showDelete)
        setAlert({ msg: '', status: undefined })
      }}>

        <ModalAlertDiv>

          {alert.status === 'ok' ?
            <>
              <CheckCircleOutlineOutlinedIcon color={"success"} style={{ fontSize: "4rem" }} />
              <h1>Success!</h1>
              <p>Calendar successfully deleted</p>
              <div>
                <Button onClick={() => {
                  setShowDelete(false)
                  setAlert({})
                }} variant="contained">Ok</Button>
              </div>
            </>
            :
            alert.status === 'ko' ?
              <>
                <h1>Error!</h1>
                <p>{alert.msg}</p>
                <Button onClick={() => {
                  setShowDelete(false)
                  setAlert({})
                }} variant="contained" color='warning'>Ok</Button>
              </>
              :
              <>
                <h1>Are you sure?</h1>
                <p>Are you sure that you want to delete this calendar?</p>
                <div>
                  <Button sx={{ marginRight: '1rem' }} onClick={() => {
                    setShowDelete(false)
                    setAlert({})
                  }} variant="contained" color='error'>Cancel</Button>

                  <Button onClick={() => {
                    confirmDelete()
                    setAlert({})
                  }} variant="contained">Yes</Button>
                </div>
              </>}


        </ModalAlertDiv>
      </ModalAlert> */}
    </TableBar>
  );
}

export default Calendars;


const customStyles = {
  margin: '3rem auto',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  overflow: 'auto',
  borderRadius: '5px',
  maxHeight: "90%",
  width: 'max-content',
}

const customStylesAlert = {
  position: 'absolute',
  top: "50%",
  left: "50%",
  right: "auto",
  bottom: "auto",
  marginRight: "-50%",
  transform: "translate(-50%, -50%)",
  height: "40%",
  minWidth: '20%',
  maxWidth: "50%",
  backgroundColor: '#FFF',
  p: 4
}

const Hours = [
  "00:00",
  "00:15",
  "00:30",
  "00:45",
  "01:00",
  "01:15",
  "01:30",
  "01:45",
  "02:00",
  "02:15",
  "02:30",
  "02:45",
  "03:00",
  "03:15",
  "03:30",
  "03:45",
  "04:00",
  "04:15",
  "04:30",
  "04:45",
  "05:00",
  "05:15",
  "05:30",
  "05:45",
  "06:00",
  "06:15",
  "06:30",
  "06:45",
  "07:00",
  "07:15",
  "07:30",
  "07:45",
  "08:00",
  "08:15",
  "08:30",
  "08:45",
  "09:00",
  "09:15",
  "09:30",
  "09:45",
  "10:00",
  "10:15",
  "10:30",
  "10:45",
  "11:00",
  "11:15",
  "11:30",
  "11:45",
  "12:00",
  "12:15",
  "12:30",
  "12:45",
  "13:00",
  "13:15",
  "13:30",
  "13:45",
  "14:00",
  "14:15",
  "14:30",
  "14:45",
  "15:00",
  "15:15",
  "15:30",
  "15:45",
  "16:00",
  "16:15",
  "16:30",
  "16:45",
  "17:00",
  "17:15",
  "17:30",
  "17:45",
  "18:00",
  "18:15",
  "18:30",
  "18:45",
  "19:00",
  "19:15",
  "19:30",
  "19:45",
  "20:00",
  "20:15",
  "20:30",
  "20:45",
  "21:00",
  "21:15",
  "21:30",
  "21:45",
  "22:00",
  "22:15",
  "22:30",
  "22:45",
  "23:00",
  "23:15",
  "23:30",
  "23:45",
]